var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFb = function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.942 18V9.95H0v-3.2h2.942V4.23C2.942 1.49 4.767 0 7.432 0c1.278 0 2.375.088 2.693.127v2.861H8.276c-1.45 0-1.73.633-1.73 1.558V6.75h3.272l-.449 3.2H6.547V18",
    fill: "currentColor"
  })));
};
export default SvgFb;